import React, { Component } from "react";
import { bindActionCreators } from "redux";
import { connect } from "react-redux";
import { formDataSaqC } from "../../data/4.0/formDataSaqC";
import ComponentSaq from "../../components/ComponentSaq";
class SaqC extends Component {
  constructor(props) {
    super(props);
    this.props = props;
    this.state = {};
  }

  render() {
    return <ComponentSaq type="C" formDataSaq={formDataSaqC} />;
  }
}

const mapStateToProps = (state) => {
  return {
    res: state.authStore.res,
  };
};
const mapDispatchToProps = (dispatch) => {
  return bindActionCreators({}, dispatch);
};

export default connect(mapStateToProps, mapDispatchToProps)(SaqC);
